import Skyflow from 'skyflow-js';
import { useSkyflow } from '../../core/hook';
const useCollectContainer = () => {
    const { skyflow } = useSkyflow();
    return skyflow.container(Skyflow.ContainerType.COLLECT);
};
export default useCollectContainer;
//# sourceMappingURL=index.js.map